import classNames from "classnames";
import { ReactNode } from "react";
import { StatChip } from "../primitives";
import { StatChipData } from "../types";
import styles from "./style.module.scss";

interface AnalyticsHeaderProps {
  title: string;
  /** Tinted chips shown inline with the title, e.g. accounts / seats / campuses. */
  stats?: StatChipData[];
  /** Filters and actions rendered on the right. */
  actions?: ReactNode;
  className?: string;
}

/** Page title row: heading, inline stat chips and the filter cluster. */
function AnalyticsHeader({
  title,
  stats = [],
  actions,
  className,
}: AnalyticsHeaderProps) {
  return (
    <div className={classNames(styles.header, className)}>
      <div className={styles.titleWrap}>
        <span className={styles.title}>{title}</span>
        {stats.length > 0 && (
          <span className={styles.stats}>
            {stats.map((stat) => (
              <StatChip key={stat.label} value={stat.value} label={stat.label} />
            ))}
          </span>
        )}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}

export default AnalyticsHeader;
